// removed by extract-text-webpack-plugin
module.exports = {"noRequiredSign":"_3gMp3pPJoJwtHoMKeosHHj","requiredSign":"_1wkinDR69MybvrsVomkfVk"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/Document/Page/Field/Edit/Signature/styles.css
// module id = 2927
// module chunks = 0